//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    metaInfo: {
        meta: [
            {charset: 'utf-8'},
            {
                name: 'viewport',
                content:
                    'width=device-width, initial-scale=1, user-scalable=no',
            },
        ],
    },
    data() {
        return {
            selectedItemIndex: 0,
            seamless: false,
            whatsappNumber: '68376602',
            selectedItem: {},
            paymentMethods: [
                {label: 'Yappy', value: 'Yappy'},
                {label: 'Efectivo', value: 'Efectivo'},
            ],
            selectedPaymentMethod: null,
            address: '',
            total: 0,
            tab: 'tradicional',
            optionsDialog: false,
            successDialog: false,
            cartDialog: false,
            cart: [],
            menu: [
                {
                    title: 'Ceviche de Pescado',
                    options: [
                        {
                            title: '8 oz',
                            price: 4,
                        },
                        {
                            title: 'Pinta',
                            price: 7,
                        },
                        {
                            title: '1/4 G.',
                            price: 13.5,
                        },
                        {
                            title: '1/2 G.',
                            price: 20,
                        },
                    ],
                    type: 'main',
                    desc:
                        'Ceviches de pescado tradicional en diversas presentaciones.',
                    filter: 'tradicional',
                },
                {
                    title: 'Ceviche de Pulpo',
                    options: [
                        {
                            title: '8 oz',
                            price: 4.75,
                        },
                        {
                            title: 'Pinta',
                            price: 10,
                        },
                        {
                            title: '1/4 G.',
                            price: 18,
                        },
                        {
                            title: '1/2 G.',
                            price: 30,
                        },
                    ],
                    type: 'main',
                    desc:
                        'Ceviches de Pulpo tradicional en diversas presentaciones.',
                    filter: 'tradicional',
                },
                {
                    title: 'Ceviche Mixto',
                    options: [
                        {
                            title: '8 oz',
                            price: 5.5,
                        },
                        {
                            title: 'Pinta',
                            price: 10,
                        },
                        {
                            title: '1/4 G.',
                            price: 18,
                        },
                        {
                            title: '1/2 G.',
                            price: 30,
                        },
                    ],
                    type: 'main',
                    desc:
                        'Ceviches Mixto tradicional en diversas presentaciones.',
                    filter: 'tradicional',
                },
                {
                    title: 'Ceviche de Camaron',
                    options: [
                        {
                            title: '8 oz',
                            price: 4.75,
                        },
                        {
                            title: 'Pinta',
                            price: 12,
                        },
                        {
                            title: '1/4 G.',
                            price: 20,
                        },
                        {
                            title: '1/2 G.',
                            price: 38,
                        },
                    ],
                    type: 'main',
                    desc:
                        'Ceviches de camaron tradicional en diversas presentaciones.',
                    filter: 'tradicional',
                },

                {
                    title: 'Ceviche de Pescado',
                    options: [
                        {
                            title: '8 oz',
                            price: 6.5,
                        },
                        {
                            title: 'Pinta',
                            price: 12,
                        },
                        {
                            title: '1/4 G.',
                            price: 20,
                        },
                    ],
                    type: 'main',
                    desc:
                        'Ceviches de pescado gourmet en diversas presentaciones.',
                    filter: 'gourmet',
                },
                {
                    title: 'Ceviche de Camaron',
                    options: [
                        {
                            title: '8 oz',
                            price: 7.25,
                        },
                        {
                            title: 'Pinta',
                            price: 13.5,
                        },
                        {
                            title: '1/4 G.',
                            price: 22,
                        },
                    ],
                    type: 'main',
                    desc:
                        'Ceviches de camaron gourmet en diversas presentaciones.',
                    filter: 'gourmet',
                },
                {
                    title: 'Ceviche Mixto',
                    options: [
                        {
                            title: '8 oz',
                            price: 8,
                        },
                        {
                            title: 'Pinta',
                            price: 15,
                        },
                        {
                            title: '1/4 G.',
                            price: 22,
                        },
                    ],
                    type: 'main',
                    desc: 'Ceviches mixto gourmet en diversas presentaciones.',
                    filter: 'gourmet',
                },
            ],
        }
    },
    methods: {
        returnFilteredMenu(menu) {
            return menu.filter(m => {
                if (m.filter === this.tab) {
                    return m
                }
            })
        },
        selectItem(index) {
            this.selectedItemIndex = index
            this.selectedItem = Object.assign({}, this.menu[index])
            this.optionsDialog = true
        },
        checkIfDuplicate() {
            let isDuplicate = false
            if (this.cart.length <= 0) {
                isDuplicate = false
            }

            this.cart.forEach(c => {
                if (
                    c.type === this.selectedItem.type &&
                    c.title === this.selectedItem.title &&
                    c.options.title === this.selectedItem.options.title
                ) {
                    isDuplicate = true
                }
            })

            return isDuplicate
        },
        addItemToCart(option) {
            this.selectedItem.options = option
            if (!this.checkIfDuplicate()) {
                this.selectedItem.amount = 1
                this.cart.push(this.selectedItem)
                this.optionsDialog = false
                this.successDialog = true
                this.calculateTotal()
            } else {
                this.cart.forEach(c => {
                    if (
                        c.type === this.selectedItem.type &&
                        c.title === this.selectedItem.title &&
                        c.options.title === this.selectedItem.options.title
                    ) {
                        c.amount++
                    }
                })
                this.optionsDialog = false
                this.successDialog = true
                this.calculateTotal()
            }
        },
        removeItemFromCart(i) {
            this.cart.splice(i, 1)
        },
        calculateTotal() {
            let total = 0
            this.cart.forEach(c => {
                if (c.price) total += c.price * c.amount
                total += c.options.price * c.amount
            })
            this.total = total
        },
        generateMessage() {
            let message =
                'Buenas, me gustaria realizar un pedido de:%0D%0A%0D%0A'
            for (let item of this.cart) {
                if (item.type == 'main')
                    message += `- (${item.amount}) ${item.title} con ${item.options.title}%0D%0A`
                if (item.type == 'extras')
                    message += `- (${item.amount}) Extra - ${item.options.title}%0D%0A`
                if (item.type == 'drinks')
                    message += `- (${item.amount}) Bebida - ${item.options.title}%0D%0A`
            }
            message += `%0D%0ADireccion: ${this.address}%0D%0AMetodo de pago: ${
                this.selectedPaymentMethod
            }%0D%0ATotal: $ ${this.total.toFixed(2)}`
            message = message.replace(/&/g, '%26')
            message = message.replace(/#/g, '%23')
            return message
        },
        sendChat() {
            if (this.address == '') {
                alert(
                    'Debes ingresar tu direccion completa para la entrega de tu pedido.'
                )
                return
            }
            if (this.selectedPaymentMethod == null) {
                alert('Debes seleccionar un metodo de pago.')
                return
            } else {
                this.$analytics.logEvent('wp-enid', {
                    content_action: 'Orden Completada',
                })
                window.location.href = `https://wa.me/507${
                    this.whatsappNumber
                }?text=${this.generateMessage()}`
            }
        },
    },

    watch: {
        selectedArea() {
            this.cart = []
            this.calculateTotal()
        },
        cart() {
            this.calculateTotal()
            if (this.cart.length > 0) {
                this.seamless = true
                this.$store.commit('SET_DISPLAYFOOTER', true)
            } else {
                this.seamless = false
                this.$store.commit('SET_DISPLAYFOOTER', false)
            }
        },
    },
    mounted() {
        this.$store.commit('SET_DISPLAYFOOTER', false)
        let path = this.$route.params.path
        this.$analytics.logEvent('wp-enid', {
            path,
        })
    },
}
